import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const SlideImage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    "assets/dog4.jpg",
    "assets/dog3.jpg",
    "assets/dog2.jpg"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [images.length])

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="relative w-full h-80 md:h-screen bg-transparent">
      {/* Background Image */}
      <div className="absolute inset-0 -z-10">
        <img
          src={images[currentIndex]}
          alt="Slide"
          className="w-full md:h-full object-cover md:object-fill lg:object-cover"
        />
      </div>

      {/* Text Overlay & Buttons */}
      <div className="md:absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 sm:px-6 md:px-12">
        <h1 className="font-bold mt-12 text-4xl md:mt-0  sm:text-3xl md:text-5xl lg:text-6xl">
          Working Towards A Brighter Tomorrow
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl mt-3 :">
          Together We Can Give Our Animals Hope
        </p>

        {/* Buttons */}
        <div className="flex  md:flex-row  space-x-4 sm:space-x-8 md:space-x-12 lg:space-x-16 mt-6">
          <Link to="/page-donate">
            <button className="border-black bg-green-800 md:my-4 md:px-20 px-6 py-2 rounded-lg font-semibold hover:bg-green-700">
              Donate
            </button>
          </Link>
          <Link to="/adoption-form">
            <button className="border-black bg-green-800 px-6 md:px-20  md:ml-0 md:mt-4 sm:px-12  py-2 rounded-lg font-semibold hover:bg-green-700">
              Adopt
            </button>
          </Link>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute top-60 md:top-3/4 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentIndex ? "bg-white" : "bg-gray-500"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default SlideImage;
